import {
  ADD_FORM_ERROR,
  REMOVE_FORM_ERROR,
  FORM_ERROR_SCROLL_TOP_OFF
} from './constants';

const INITIAL_STATE = {
  formError: null,
  scrollTop: false
};

const reducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case ADD_FORM_ERROR: {
      return {
        formError: action.payload,
        scrollTop: true
      };
    }
    case FORM_ERROR_SCROLL_TOP_OFF: {
      return {
        formError: { ...state.formError },
        scrollTop: false
      };
    }
    case REMOVE_FORM_ERROR: {
      return {
        formError: null,
        scrollTop: false
      };
    }
    default:
      return state;
  }
};

export default reducer;
